// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ke2s","index":"styles_index__ubQVQ"};